import { render, staticRenderFns } from "./AuthorizationCode.vue?vue&type=template&id=70c01758&scoped=true&"
import script from "./AuthorizationCode.vue?vue&type=script&lang=js&"
export * from "./AuthorizationCode.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationCode.vue?vue&type=style&index=0&id=70c01758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c01758",
  null
  
)

export default component.exports